import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'

let hostname: string

// This package is being imported in playwright because of @surglogs-app/network, since playwright doesn't run
// in browser environment, window is undefined and playwright breaks
if (typeof window !== 'undefined') {
  hostname = window.location.hostname
}

export const getSentryOpts = (config: {
  sentryDsn: string
  sentryProjectId: string
  appVersion?: string | undefined
}): Sentry.BrowserOptions => ({
  dsn: config.sentryDsn,
  environment: hostname,
  release: config.appVersion,
  allowUrls: [/.*surglogs\.com/],
  ignoreErrors: [
    /Loading chunk \d+ failed/i,
    /Loading CSS chunk \d+ failed/i,
    /Failed to fetch/i,
    /Object captured as promise rejection with keys: response/i,
    /Non-Error promise rejection captured with value: undefined/i,
    /Non-Error exception captured with keys: /i,
    /Illegal invocation/i,
    // Should be recaptcha error, not affecting users -> e.g. https://github.com/getsentry/sentry-javascript/issues/5833
    /Non-Error promise rejection captured with value: Timeout/i,
    /Timeout/i,
    // Should be related to outlook redirect to app and scanning of safe links, not affecting users -> e.g. https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
    /Non-Error promise rejection captured with value: Object Not Found Matching/i,
    /Object Not Found Matching/i,
    /Event `Event` (type=error) captured as promise rejection/i,
  ],
  // Custom fingerprinting to prevent duplicated issues in Jira with same error message / title
  beforeSend(event) {
    const errorTitle = event.exception?.values?.[0].value
    event.fingerprint = [errorTitle || '{{ default }}']

    return event
  },
  integrations: [
    // new CaptureConsole({ levels: ['error'] }),
    Sentry.browserTracingIntegration({
      // tracePropagationTargets: [
      //   'localhost',
      //   'app.bears.develop.surglogs.com',
      //   'app.staging.surglogs.com',
      //   /^\//,
      // ],
      /**
       * @TODO
       * turn this on for correct tracking in Sentry performance, has to be used together with:
       * const useSentryRoutes = wrapUseRoutes(useRoutes)
       * which is causing bugs with infinite loading of endpoints in settings (working schedule or devices)
       * but only on production build
       */
      // routingInstrumentation: Sentry.reactRouterV6Instrumentation(
      //   useEffect,
      //   useLocation,
      //   useNavigationType,
      //   createRoutesFromChildren,
      //   matchRoutes,
      // ),
    }),
    posthog.sentryIntegration({
      organization: 'surglogs-inc',
      projectId: Number(config.sentryProjectId),
      severityAllowList: ['error'],
    }),
  ],
  tracesSampleRate: hostname === 'surglogs.com' ? 0.15 : 0.05, // set to 1 if you want to send all transactions
  // tracesSampleRate: 1,
  // debug: process.env.NODE_ENV === 'development',
  debug: false,
})
